// https://mui.com/material-ui/customization/transitions/?srsltid=AfmBOorYpJQAzTwy_zMr7rv7-0P6epSIucmYZkcRLpVZUNdiNt08aFPT
export const MUI_STANDARD_TRANSITION_DURATION = 300
